import Vue from 'vue'
import Router from 'vue-router'
import { store } from '@/store/store'

import NotFoundView from '@/components/error/404.vue'

import DashboardMain from '@/components/view/dashboardMain/main.vue'
import Dashboard from '@/components/view/dashboard/Dashboard'
import Depausersregister from '@/components/view/dashboard/Depausersregister'
import Depausersapplyprojectapplicantsbystatus from '@/components/view/dashboard/Depausersapplyprojectapplicantsbystatus'
import Depatopfiveusersapplyproject from '@/components/view/dashboard/Depatopfiveusersapplyproject'
import Customers from '@/components/view/dashboard/Customers.vue'

import WelcomeMessage from '@/components/view/welcomemessage/WelcomeMessage'

import Account from '@/components/view/allbots/Account'
import Template from '@/components/view/template/template'
import Broadcast from '@/components/view/broadcast/Broadcast'
import Conversation from '@/components/view/intent/Conversation'
import Comment from '@/components/view/intent/CommentToInbox'
import Training from '@/components/view/intent/Training'
import Billing from '@/components/view/billing/main.vue'
import Upgrade from '@/components/view/billing/Upgrade'
import Ticket from '@/components/view/template/ticket/main.vue'
import TechHunt from '@/components/view/techhunt/main.vue'
import TechhuntCouponreport from '@/components/view/techhuntCouponreport/main.vue'
import TechhuntTechproviderandproductreport from '@/components/view/techhuntTechproviderandproductreport/main.vue'
import TechhuntApprovedbydepa from '@/components/view/techhuntApprovedbydepa/main.vue'
import TechhuntApprovedSkillbydepa from '@/components/view/techhuntApprovedSkillbydepa/main.vue'
import TechhuntTrafficreport from '@/components/view/techhuntTrafficreport/main.vue'
import TechhuntTechhuntsetting from '@/components/view/techhuntTechhuntsetting/main.vue'
import TechhuntTapSetting from '@/components/view/techhuntTapSetting/main.vue'
import TechhuntMaster from '@/components/view/techhuntMaster/main.vue'
import ConsentApprove from '@/components/view/consentApprove/main.vue'

import Voucherreport from '@/components/view/voucherreport/main.vue'

import Member from '@/components/view/member/main.vue'
import MemberInfo from '@/components/view/memberInfo/main.vue'
import MemberType from '@/components/view/memberType/main.vue'
import Jobd2u from '@/components/view/jobd2u/main.vue'
import Project from '@/components/view/project/main.vue'
import ProjectMember from '@/components/view/projectMember/main.vue'
import ProjectMemberCount from '@/components/view/projectMemberCount/main.vue'
import ProjectMaster from '@/components/view/projectMaster/main.vue'

import Setup from '@/components/view/getstarted/Setup'

import LivechatView from '@/components/view/livechat/LivechatView'
import Productandbranch from '@/components/view/ticket2/productandbranch/main.vue'
import Ticket2profile from '@/components/view/ticket2/profile/main.vue'
import Ticket2management from '@/components/view/ticket2/management/main.vue'


Vue.use(Router)

const allLang = ['en', 'th', 'la']

const routes = [
  {
    path: '/',
    beforeEnter(to, from, next) {
      let language = to.params.lang
      if (!allLang.includes(language)) {
        return next('th')
      }
      store.dispatch('setLang', language)

      return next()
    }
  },
  {
    path: '/linenotify',
    // beforeEnter: guardRoute,
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        component: function(resolve) {
          require(['@/components/view/linenotify/Linenotify.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/connect_quality',
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        component: function(resolve) {
          require(['@/components/view/linenotify/Prepare.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/:lang',
    beforeEnter(to, from, next) {
      let language = to.params.lang
      if (!allLang.includes(language)) {
        return next('th')
      }
      store.dispatch('setLang', language)

      return next()
    },
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        redirect: 'allbots',
      },
      {
        path: 'nigol',
        name: 'nigol',
        component: function(resolve) {
          require(['@/components/login/Nigol.vue'], resolve)
        }
      },
      {
        path: 'sso',
        name: 'sso',
        component: function(resolve) {
          require(['@/components/login/Sso.vue'], resolve)
        }
      },
      {
        path: 'login',
        name: 'login',
        component: function(resolve) {
          require(['@/components/login/Login.vue'], resolve)
        }
      },
      {
        path: 'callbackthaid',
        name: 'callbackthaid',
        component: function(resolve) {
          require(['@/components/login/callbackThaiD.vue'], resolve)
        }
      },
      {
        path: 'callbackazure',
        name: 'callbackazure',
        component: function(resolve) {
          require(['@/components/login/callbackAzure.vue'], resolve)
        }
      },
      {
        path: 'allbots',
        name: 'allbots',
        component: Account,
        beforeEnter: guardRoute,
        meta: {
          title: 'All Bots'
        },
      },
      {
        path: 'welcome',
        name: 'welcome message',
        component: WelcomeMessage,
        beforeEnter: guardRoute,
        meta: {
          title: 'Welcome Message'
        },
        checked: false
      },
      {
        path: 'conversation',
        name: 'conversation',
        component: Conversation,
        beforeEnter: guardRoute,
        meta: {
          title: 'Conversation'
        },
        checked: false
      },
      {
        path: 'member',
        name: 'member',
        component: Member,
        beforeEnter: guardRoute,
        meta: {
          title: 'Member'
        },
        checked: false,
        children: [
          {
            path: 'memberInfo',
            name: 'memberInfo',
            component: MemberInfo,
            beforeEnter: guardRoute,
            meta: {
              title: 'Member info'
            },
            checked: false
          },
          {
            path: 'memberType',
            name: 'memberType',
            component: MemberType,
            beforeEnter: guardRoute,
            meta: {
              title: 'Member type'
            },
            checked: false
          }
        ]
      },
      {
        path: 'livechat',
        name: 'livechat',
        component: LivechatView,
        beforeEnter: guardRoute,
        meta: {
          title: 'Livechat'
        },
        checked: false
      },
      {
        path: 'project',
        name: 'project',
        component: Project,
        beforeEnter: guardRoute,
        meta: {
          title: 'Project'
        },
        checked: false,
        children: [
          {
            path: 'projectMember',
            name: 'projectMember',
            component: ProjectMember,
            beforeEnter: guardRoute,
            meta: {
              title: 'Project member'
            },
            checked: false
          },
          {
            path: 'projectMemberCount',
            name: 'projectMemberCount',
            component: ProjectMemberCount,
            beforeEnter: guardRoute,
            meta: {
              title: 'Project count'
            },
            checked: false
          },
          {
            path: 'projectMaster',
            name: 'projectMaster',
            component: ProjectMaster,
            beforeEnter: guardRoute,
            meta: {
              title: 'Project master'
            },
            checked: false
          }
        ]
      },
      {
        path: 'techhunt',
        name: 'Techhunt',
        component: TechHunt,
        beforeEnter: guardRoute,
        meta: {
          title: 'Tech hunt'
        },
        checked: false,
        children: [
          {
            path: 'techhuntMaster',
            name: 'techhuntMaster',
            component: TechhuntMaster,
            beforeEnter: guardRoute,
            meta: {
              title: 'techhunt master'
            },
            checked:false,
          },
          {
            path: 'techhuntCouponreport',
            name: 'techhuntCouponreport',
            component: TechhuntCouponreport,
            beforeEnter: guardRoute,
            meta: {
              title: 'Coupon Report'
            },
            checked:false,
          },
          {
            path: 'techhuntTechproviderandproductreport',
            name: 'techhuntTechproviderandproductreport',
            component: TechhuntTechproviderandproductreport,
            beforeEnter: guardRoute,
            meta: {
              title: 'provider & product'
            },
            checked:false,
          },
          {
            path: 'techhuntApprovedbydepa',
            name: 'techhuntApprovedbydepa',
            component: TechhuntApprovedbydepa,
            beforeEnter: guardRoute,
            meta: {
              title: 'approved by depa'
            },
            checked:false,
          },
          {
            path: 'techhuntApprovedSkillbydepa',
            name: 'techhuntApprovedSkillbydepa',
            component: TechhuntApprovedSkillbydepa,
            beforeEnter: guardRoute,
            meta: {
              title: 'approved skill by depa'
            },
            checked:false,
          },
          {
            path: 'consentApprove',
            name: 'consentApprove',
            component: ConsentApprove,
            beforeEnter: guardRoute,
            meta: {
              title: 'consent approve'
            },
            checked:false,
          },
          {
            path: 'techhuntTrafficreport',
            name: 'techhuntTrafficreport',
            component: TechhuntTrafficreport,
            beforeEnter: guardRoute,
            meta: {
              title: 'traffic report'
            },
            checked:false,
          },
          {
            path: 'techhuntTechhuntsetting',
            name: 'techhuntTechhuntsetting',
            component: TechhuntTechhuntsetting,
            beforeEnter: guardRoute,
            meta: {
              title: 'techhunt setting'
            },
            checked:false,
          },
          {
            path: 'techhuntTapSetting',
            name: 'techhuntTapSetting',
            component: TechhuntTapSetting,
            beforeEnter: guardRoute,
            meta: {
              title: 'tab menu setting'
            },
            checked:false,
          }
        ]
      },
      {
        path: 'voucherreport',
        name: 'voucherreport',
        component: Voucherreport,
        beforeEnter: guardRoute,
        meta: {
          title: 'Voucher Report'
        },
        checked:false,
      },
      {
        path: '',
        name: 'event',
        meta: {
          title: 'Event'
        },
        checked:false,
      },
      // {
      //   path: 'Jobd2u',
      //   name: 'Jobd2u',
      //   component: Jobd2u,
      //   beforeEnter: guardRoute,
      //   meta: {
      //     title: 'JOBD2U'
      //   },
      //   checked:false,
      // },
      {
        path: 'allinonechat',
        name: 'allinonechat',
        component: LivechatView,
        beforeEnter: guardRoute,
        meta: {
          title: 'Livechat'
        },
      },
      {
        path: 'broadcast',
        name: 'broadcast',
        component: Broadcast,
        beforeEnter: guardRoute,
        meta: {
          title: 'Broadcast'
        },
        checked:false,
      },
      {
        path: 'template',
        name: 'template',
        component: Template,
        beforeEnter: guardRoute,
        meta: {
          title: 'Plugin'
        },
      },
      {
        path: 'rolemanager',
        name: 'rolemanager',
        component: Ticket,
        beforeEnter: guardRoute,
        meta: {
          title: 'Role Manager'
        },
        checked:false,
      },
      {
        path: 'dashboardMain',
        name: 'dashboardMain',
        component: DashboardMain,
        beforeEnter: guardRoute,
        meta: {
          title: 'Report'
        },
        checked:false,
        children: [
          {
            path: 'dashboard',
            name: 'dashboard',
            component: Dashboard,
            beforeEnter: guardRoute,
            meta: {
              title: 'ภาพรวม'
            },
            checked: false
          },
          {
            path: 'depausersregister',
            name: 'depausersregister',
            component: Depausersregister,
            beforeEnter: guardRoute,
            meta: {
              title: 'จำนวนผู้ลงทะเบียน'
            },
            checked: false
          },
          {
            path: 'depausersapplyprojectapplicantsbystatus',
            name: 'depausersapplyprojectapplicantsbystatus',
            component: Depausersapplyprojectapplicantsbystatus,
            beforeEnter: guardRoute,
            meta: {
              title: 'จำนวนผู้สมัครเข้าร่วมโครงการ'
            },
            checked: false
          },
          {
            path: 'depatopfiveusersapplyproject',
            name: 'depatopfiveusersapplyproject',
            component: Depatopfiveusersapplyproject,
            beforeEnter: guardRoute,
            meta: {
              title: 'Top โครงการ'
            },
            checked: false
          },
          {
            path: 'customers',
            name: 'customers',
            component: Customers,
            beforeEnter: guardRoute,
            meta: {
              title: 'ลูกค้า'
            },
            checked: false
          },
        ]
      },
      {
        path: 'comment',
        name: 'Comment to inbox',
        component: Comment,
        beforeEnter: guardRoute,
        meta: {
          title: 'Reply comment'
        },
      },
      {
        path: '',
        name: 'Training',
        // component: Training,
        // beforeEnter: guardRoute,
        meta: {
          title: 'Training'
        },
        checked:false,
      },
      {
        path: 'setup',
        name: 'Setup',
        component: Setup,
        beforeEnter: guardRoute,
        meta: {
          title: 'Get Started'
        },
      },
      {
        path: 'productandbranch',
        name: 'productandbranch',
        component: Productandbranch,
        beforeEnter: guardRoute,
        meta: {
          title: 'Product and branch'
        },
      },
      {
        path: 'ticket2profile',
        name: 'ticket2profile',
        component: Ticket2profile,
        beforeEnter: guardRoute,
        meta: {
          title: 'Profile'
        },
      },
      {
        path: 'ticket2management',
        name: 'ticket2management',
        component: Ticket2management,
        beforeEnter: guardRoute,
        meta: {
          title: 'Profile'
        },
      },
      {
        path: 'upgrade',
        name: 'Upgrade',
        component: Upgrade,
        beforeEnter: guardRoute,
        meta: {
          title: 'Upgrade package to premium plan'
        },
      },
      {
        path: 'billing',
        name: 'setting',
        component: Billing,
        beforeEnter: guardRoute,
        meta: {
          title: 'Setting'
        },
        checked:false,
      },
      {
        // not found handler
        path: '*',
        component: NotFoundView
      }
    ]
  }
]

const router = new Router({
  routes,
  mode: 'history'
})
router.onError(error => {
  if (/loading chunk \d* failed./i.test(error.message)) {
    window.location.reload()
  }
})
const title = 'Depa'
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags)
  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags)

  // If a route with a title was found, set the document (page) title to that value.
  if (['chat2pay', 'setup_c2p'].includes(to.name)) {
    document.title = nearestWithTitle.meta.title
  } else if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title + ' | ' + title
  } else {
    document.title = title
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el =>
    el.parentNode.removeChild(el)
  )

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement('meta')

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key])
      })

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '')

      return tag
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag))

  next()
})

export default router

function guardRoute(to, from, next) {
  var query = { ...to.query }
  query.redirect = to.fullPath

  if (!store.getters.isLoggedIn) {
    if (to.query.usertype == 'nigol') {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: { redirect: to.fullPath, utm_source: to.query.utm_source }
      })
    } else {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: { redirect: to.fullPath, utm_source: to.query.utm_source }
      })
    }
  } else {
    if (store.state.isFacebook) {
      if (store.state.selectedBot) {
        store.dispatch('updateBotDetail').then(
          function(response) {
            // checkTokenStatus(next)
            next()
          },
          function(e) {
            next({
              path: '/' + store.getters.currentLang + '/nigol',
              query: query
            })
          }
        )
      }
      next()
    } else {
      if (store.state.selectedBot) {
        store.dispatch('updateBotDetail').then(
          function(response) {
            // checkTokenStatus(next)
            next()
          },
          function(e) {
            next({
              path: '/' + store.getters.currentLang + '/nigol',
              query: query
            })
          }
        )
      }

      next()
    }
  }
}

function guardPartnerRoute(to, from, next) {
  if (!store.getters.isLoggedIn) {
    next({
      path: '/' + store.getters.currentLang + '/nigol',
      query: { redirect: to.fullPath, utm_source: to.query.utm_source }
    })
  } else {
    if (store.state.partner_code) {
      next()
    } else {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: { redirect: to.fullPath, utm_source: to.query.utm_source }
      })
    }
  }
}

function checkTokenStatus(next) {
  var vm = router.app
  if (
    store.state.selectedBot &&
    Object.keys(store.state.selectedBot).length &&
    store.state.selectedBot.hasOwnProperty('statustoken') &&
    !store.state.selectedBot.statustoken
  ) {
    // Swal({
    //   icon: 'error',
    //   width: 650,
    //   allowOutsideClick: false,
    //   confirmButtonColor: '#d33',
    //   title: vm.$t('Hey! Your chatbot has connection error.'),
    //   html: vm.$t('Admin page please log into the zwiz system') + ' <a href="https://cms.zwiz.ai/en/login">(https://cms.zwiz.ai/en/login)</a> ' + vm.$t('again.')
    // }).then(() => {
    //   if (store.getters.isFacebook) {
    //     logout(next)
    //   }
    // })
  }
}

function logout(next) {
  var isFacebook = store.getters.isFacebook
  store.dispatch('logout', null).then()
  if (isFacebook) {
    next({
      path: '/' + store.getters.currentLang + '/nigol'
    })
  } else {
    next({
      path: '/' + store.getters.currentLang + '/nigol'
    })
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js